/* UserOriginModel */

import { types } from 'mobx-state-tree'

/* Model Properties */
const props = {
    publisherId: types.optional(types.string, ""),
    appId: types.optional(types.string, ""),
    seedcode: types.optional(types.string, "")
}

/* Model Actions */
const actions = (self) => ({
    setOrigin(publisherId, appId, seedcode) {
        self.publisherId = publisherId
        self.appId = appId
        self.seedcode = seedcode
    }
})

const UserOriginModel = types
  .model('UserOriginModel')
  .props(props)
  .actions(actions)

  export default UserOriginModel